//tslint:disable
import React, { useState, useEffect, useRef } from "react";
import DragAndDropWord from "./DragAndDropWord";
import DragAndDropImage from "./DragAndDropImage";
import DragAndDropWordMatching from "./DragAndDropWordMatching";

const DragAndDrop = ({ course, topic, lesson, dragDropInfo, edit }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (dragDropInfo) {
      setType(dragDropInfo.kind)
    }
  }, [dragDropInfo])

  useEffect(() => {
    $(ref.current)
      .select2({
        placeholder: "Выберите тип",
        width: '244px',
        minimumResultsForSearch: Infinity
      })
      .on('change', handleAddrTypeChange);
  }, [])

  const [type, setType] = useState();
  const handleAddrTypeChange = (e) => setType(e.target.value)

  const renderType = () => {
    switch (type) {
      case 'word_sequence':
        return <DragAndDropWord course={course} topic={topic} lesson={lesson} dragDropInfo={dragDropInfo} edit={edit} />
      case 'value_sorting':
        return <DragAndDropImage course={course} topic={topic} lesson={lesson} dragDropInfo={dragDropInfo} edit={edit} />
      case 'word_matching':
        return <DragAndDropWordMatching course={course} topic={topic} lesson={lesson} dragDropInfo={dragDropInfo} edit={edit} />
    }
  }

  return (
    <div>
      {!edit && <select ref={ref} onChange={handleAddrTypeChange}>
        <option></option>
        <option selected={type === 'word_sequence'} value="word_sequence">Последовательность слов</option>
        <option selected={type === 'value_sorting'} value="value_sorting">Картинки в корзину</option>
        <option selected={type === 'word_matching'} value="word_matching">Пары слов</option>
      </select>}
      {renderType()}
    </div>
  );
}

export default React.memo(DragAndDrop);


// WEBPACK FOOTER //
// ./app/frontend/components/DragAndDrop.js